import React from 'react'
import { GoTriangleUp } from "react-icons/go";
import { useState } from 'react';
import { IoIosArrowDropup } from "react-icons/io";
import { IoIosArrowDropdown } from "react-icons/io";

const CibilInsight = (props) => {
    const [isExpanded, setExpanded] = useState(false);
    const toggleExpand = () => {
        setExpanded(!isExpanded);
    };

    return (
    <div className='shadow-sm bg-white hover:shadow-md rounded-lg'>
        <div className='h-20 3xl:h-32 flex flex-row items-center justify-around px-2 text-center'>
        <div className='flex items-center justify-center border-r-2 border-gray-300 h-[70%] px-2 w-1/5'><p className='max-lg:text-lg text-xl sm:text-md text-center'>{props.title}</p></div>
        <div className='flex flex-col items-center justify-center border-r-2 border-gray-300 h-[70%] px-2 w-1/5'>
            <p className='md:text-xs lg:text-sm text-center'>{props.accounts}</p>
            <p className='md:block hidden md:text-xs text-center text-gray-500'>{props.accountDetails}</p>
            <p className='md:block hidden md:text-xs text-center text-gray-500'>{props.accountDetails1}</p>
        </div>
        <div className='flex flex-row justify-center items-center gap-0.5 ml-[-1%] border-r-2 border-gray-300 h-[70%] w-2/5'>
            <div className='w-[16%]  cursor-pointer' text-sm >
                <div id='scorebar-0' className='bg-red-500 h-3 rounded-l-md' />
            </div>
            <div className='w-[8%] cursor-pointer' text-sm >
                <div id='scorebar-1' className='bg-primary h-3'/>
            </div>
            
            <div className='w-[6%] cursor-pointer' text-sm >
                <div id='scorebar-2' className='bg-text_color2  h-3' />
            </div>
            
            <div className='w-[6%] cursor-pointer' text-sm >
                <div id='scorebar-3' className='bg-text_color3 h-3' />
            </div>

            <div className='relative w-[6%] cursor-pointer' text-sm  >
                <div id='scorebar-4' className='bg-text_color4 h-3 rounded-r-md'/>
                <div className='flex flex-col items-center justify-start absolute top-100 lg:-left-4 text-xs text-gray-500'>
                    <GoTriangleUp className='text-text_color4' />
                    <p className='max-lg:hidden'> Excellent </p>
                </div>
            </div>
        </div>
        {!isExpanded ? 
            <div className='flex flex-row justify-center items-center w-1/6'>
                <button onClick = {()=> toggleExpand()} className="flex flex-row justify-around items-center bg-primary hover:text-gray-200 px-2 text-white rounded-lg h-12 w-[80%] max-xl:text-xs">View More <IoIosArrowDropdown className='max-xl:hidden block mt-[1px]'/></button>
            </div> :
            <div className='flex flex-row justify-center items-center w-1/6'>
                <button onClick = {()=> toggleExpand()} className="flex flex-row justify-around items-center bg-primary hover:text-gray-200 px-2 text-white rounded-lg h-12 w-[80%] max-xl:text-xs">View Less <IoIosArrowDropup className='mt-[1px]'/></button>
            </div>
        }
        </div>
        <div className={`grid transition-smooth will-change-auto duration-300 overflow-hidden ${isExpanded ? "visible grid-rows-[1fr] opacity-100" : "invisible grid-rows-[0fr] opacity-0"}`}>
            <div className={`flex items-center justify-center overflow-hidden mb-2`}>
                {props.content}
            </div>
        </div>
    </div>
    )
}

export default CibilInsight